// Build-time configuration (Vite env vars; see .env.example).
// With no Supabase URL the app runs in "local mode": data lives on this device only,
// seeded with sample data. That is how the overnight preview and offline dev work.

const env = import.meta.env;

export const config = {
  supabaseUrl: (env.VITE_SUPABASE_URL as string | undefined) ?? '',
  supabaseAnonKey: (env.VITE_SUPABASE_ANON_KEY as string | undefined) ?? '',
  vapidPublicKey: (env.VITE_VAPID_PUBLIC_KEY as string | undefined) ?? '',
  inboxAddress: (env.VITE_INBOX_ADDRESS as string | undefined) || '[inbox]@gmail.com',
  /** Optional Amazon Associates tag, only if the cart link turns out to need one. */
  amazonAssociateTag: (env.VITE_AMAZON_ASSOCIATE_TAG as string | undefined) ?? '',
  isPreview: env.MODE === 'preview',
  version: '0.1.0',
  /** Which commit this build is, and when it was built: Settings shows it so we can tell an update arrived. */
  build: { sha: __BUILD_SHA__, time: __BUILD_TIME__ },
};

/** The preview build always uses sample data, even when .env.local has real settings. */
export const useSupabase = !config.isPreview && Boolean(config.supabaseUrl && config.supabaseAnonKey);

/**
 * A real (non-preview) production build must have Supabase configured. Without this, a
 * missing or misspelled env var on the host would quietly ship local mode: sample data
 * and no sign-in.
 */
export const missingProductionConfig = env.PROD && !config.isPreview && !useSupabase;
